import { useSettings, SocialLinks } from "@/components/SocialLinks";
import { Header } from "@/components/Header";
import { MapPin, ExternalLink, Compass } from "lucide-react";

export default function Region() {
  const settings = useSettings();
  const items = settings?.region || [];
  const cats = [...new Set(items.map((i) => i.category))];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-rose-brand mb-3"><Compass className="w-4 h-4" /> Autour des cottages</span>
        <h1 className="font-serif text-4xl sm:text-5xl text-olive">À faire dans la région</h1>
        <p className="text-muted-foreground mt-2 max-w-xl">Nos coups de cœur à Rosselange, Rombas et alentours : balades, visites, restaurants et sorties.</p>

        {items.length === 0 && (
          <div className="mt-10 rounded-2xl bg-white border border-border p-8 text-center text-muted-foreground" data-testid="region-empty">
            Les suggestions arrivent bientôt. L'équipe complète cette page depuis l'Administration.
          </div>
        )}

        {cats.map((cat) => (
          <section key={cat} className="mt-10">
            <h2 className="font-serif text-2xl text-olive mb-4">{cat}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid={`region-category-${cat}`}>
              {items.filter((i) => i.category === cat).map((it, idx) => (
                <article key={idx} className="rounded-2xl bg-white border border-border overflow-hidden hover-lift flex flex-col" data-testid="region-item">
                  {it.image && <img src={it.image} alt={it.title} className="w-full aspect-[4/3] object-cover" />}
                  <div className="p-5 flex-1 flex flex-col">
                    <h3 className="font-serif text-xl text-olive">{it.title}</h3>
                    {it.distance && <p className="text-xs text-muted-foreground mt-1 inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {it.distance}</p>}
                    {it.text && <p className="text-sm text-foreground mt-2 flex-1 whitespace-pre-line">{it.text}</p>}
                    {it.link && <a href={it.link} target="_blank" rel="noreferrer" className="mt-3 text-sm text-rose-brand font-semibold inline-flex items-center gap-1 hover:underline">En savoir plus <ExternalLink className="w-3.5 h-3.5" /></a>}
                  </div>
                </article>
              ))}
            </div>
          </section>
        ))}
        <div className="mt-12 flex justify-center"><SocialLinks /></div>
      </div>
    </div>
  );
}
